




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as complianceLinks from "@/data/sources/complianceLinks"
import {executeQuery} from "@/data/repos/query";

@Component({
  components: {
    DataGrid,
  },
})
export default class ComplianceWorstPerformingElementsDrillDown extends Vue {
  @Prop() public args!: { locationId: number, element: string, riskLabels: string[] }
  public fields = [
    {name: 'ElementDescription', title: 'Element', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.element},
    {name: 'BuildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.building},
    {name: 'Code', title: 'Code', dataType: DataType.Text, sort: 1},
    {name: 'Reason', title: 'Reason', dataType: DataType.Text, sort: 1},
    {name: 'expirydate', title: 'Expiry Date', dataType: DataType.Date, sort: 1},
    {name: 'responsiblePerson', title: 'Responsible Person', dataType: DataType.Text, sort: 1},
    {name: 'riskLabel', title: 'Risk', dataType: DataType.Text, sort: 1},
    {name: 'Risk', title: 'Risk Value', dataType: DataType.Number, sort: 1},
  ]

  public getData(offset = 0, limit = 250) {
    return executeQuery("idr", "compliance.worstPerformingElementsDrillDown",
      {locationId: this.args.locationId, element: this.args.element, riskLabels: this.args.riskLabels},
      undefined,
      offset, limit)
  }
}
